/**
 * Canonical dark-theme color values shared across the Flux stack.
 *
 * This is the **single source of truth** for every dark-mode color used in
 * both the frontend MUI theme (`frontend/src/resources/Theme.tsx`) and the
 * backend Copilot chart-styling prompts.  When a color changes, change it
 * here and both consumers pick it up automatically.
 *
 * Only the values that are referenced by more than one consumer belong here.
 * MUI-only variants (e.g. `primary.dark`, `primary.light`, `contrastText`)
 * stay in Theme.tsx.
 */
export const fluxDarkThemeColors = {
    /** `background.default` in MUI, figure background in charts. */
    backgroundDefault: "#212121",
    /** `background.paper` in MUI, axes background in charts. */
    backgroundPaper: "#2E2E2E",

    /** `text.primary` in MUI, title / axis-label color in charts. */
    textPrimary: "#FFFFFF",
    /** `text.secondary` in MUI, tick / legend color & grid color in charts. */
    textSecondary: "#A3A3A3",

    /** `divider` in MUI, axis-spine color in charts. */
    divider: "#191B1B",

    /** `primary.main` — teal-green accent. */
    primaryMain: "#1DFDC0",
    /** `secondary.main` — blue accent. */
    secondaryMain: "#00B2FF",
    /** `warning.main` — orange. */
    warningMain: "#FF9800",
    /** `error.main` — red. */
    errorMain: "#F44336",
    /** `success.main` — green. */
    successMain: "#4CAF50",
    /** `info.main` — blue. */
    infoMain: "#2196F3",
} as const;
